import { createI18n } from '@learnforge/i18n';
import { locales } from './locales';
import type { ArithKey } from './locales/keys';

export const i18n = createI18n<ArithKey>({
  gameId: 'arithmetic',
  locales,
});

export type ArithI18n = typeof i18n;
